import { ClassResponse } from '../../class/type';

export function generateClassEyebrow(classResponse: ClassResponse) {
  const { fields } = classResponse;
  const { units } = fields;
  const eventLocation = units?.[0]?.fields.eventLocation ?? {};
  const eventTime = units?.[0]?.fields.eventTime ?? '';
  const auLearningContentType =
    units?.[0]?.fields?.auLearningContentType?.fields?.name ?? '';
  const eventLocationName = eventLocation?.fields?.name || '';
  const eventYear = eventTime ? new Date(eventTime).getFullYear() : '';

  const classEyebrowFields = [];
  if (auLearningContentType) {
    classEyebrowFields.push(auLearningContentType);
  }
  if (eventLocationName + eventYear) {
    classEyebrowFields.push(`${eventLocationName} ${eventYear}`);
  }
  return classEyebrowFields.join(' / ');
}
